import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import constants from 'constants';
import actions from 'actions';
import axios from 'axios';

const {
  addLandingDataUser,
  addAboutDataUser,
  addRequestError
} = actions;

const {
  LOAD_LANDING_DATA_USER_SAGA,
  API_LANDING_DATA_USER,
  LOAD_ABOUT_DATA_USER_SAGA,
  API_ABOUT_DATA_USER
} = constants;


const apiLoadLandingData = () => {
  return axios.get(API_LANDING_DATA_USER)
};

const apiLoadAboutData = () => {
  return axios.get(API_ABOUT_DATA_USER)
};

function* loadLandingDataUser() {
  try {
    const response = yield call(apiLoadLandingData);
    const data = response.data.landing.body;
    yield put(addLandingDataUser(data));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

function* loadAboutDataUser() {
  try {
    const response = yield call(apiLoadAboutData);
    const data = response.data.about;
    yield put(addAboutDataUser(data));

  } catch (e) {
    yield put(addRequestError(e.response))
  }
}

function* __loadLandingDataUser() {
  yield takeEvery(LOAD_LANDING_DATA_USER_SAGA, loadLandingDataUser)
}

function* __loadAboutDataUser() {
  yield takeEvery(LOAD_ABOUT_DATA_USER_SAGA, loadAboutDataUser)
}

export {
  __loadLandingDataUser,
  __loadAboutDataUser
};



// WEBPACK FOOTER //
// ./src/sagas/landing.js